// extracted by mini-css-extract-plugin
export default {"title":"styles_title__0lYxo","container":"styles_container__khwOG","submit":"styles_submit__FgJ+B"};